import { ref } from "vue";
import type { BatchChanges, Link, Task } from "@dhtmlx/trial-vue-gantt";
import { applyBatchChanges } from "./applyBatchChanges";

export interface DemoDataSet {
  tasks: Task[];
  links: Link[];
}

export function createBatchSaveData(applyBatch: (changes: BatchChanges) => void) {
  return {
    batchSave: applyBatch
  };
}

export function useDemoBatchState(initialData: DemoDataSet) {
  const tasks = ref<Task[]>(initialData.tasks);
  const links = ref<Link[]>(initialData.links);

  const applyBatch = (changes: BatchChanges) => {
    const next = applyBatchChanges(tasks.value, links.value, changes);
    tasks.value = next.tasks;
    links.value = next.links;
  };

  return {
    tasks,
    links,
    applyBatch,
    data: createBatchSaveData(applyBatch)
  };
}
